import { useEffect, useState } from "react";

/**
 * Whole seconds left before a rate-limited action may run again, 0 when done (RV2.7). The deadline
 * is fixed at mount; callers restart the count by remounting with a new `key`.
 */
export function useRetryCountdown(seconds: number): number {
  const [deadline] = useState(() => Date.now() + seconds * 1000);
  const [now, setNow] = useState(() => Date.now());
  const secondsLeft = Math.max(0, Math.ceil((deadline - now) / 1000));

  const done = secondsLeft === 0;

  useEffect(() => {
    if (done) return;
    // A timer callback sets the state, never the effect body, so no render loop is possible.
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [done]);

  return secondsLeft;
}
